import AdminLayout from '@/components/Layouts/AdminLayout/AdminLayout';
import HomeworkTable from '@/components/organisms/Table/HomeworkTable';

const AdminLearningGradingList = () => {
  return (
    <AdminLayout>
      <section className='p-6'>
        <div className='flex items-center justify-between mb-6'>
          <h1 className='text-2xl font-bold'>숙제 채점하기</h1>
        </div>
        <div className='bg-white rounded-2xl shadow-sm p-4'>
          <HomeworkTable type='admin' />
        </div>
      </section>
    </AdminLayout>
  );
};

export default AdminLearningGradingList;

